import React from 'react';
import PropTypes from 'prop-types';

import Style from './infoTextTooltip.module.css';
import { Tooltip, InfoText, CopyToClipboardLink } from '@weezevent/nacre';

export function TooltipContentCopy({ label = '', tooltipCopy = true }) {
    if (!label) {
        return null;
    }

    if (!tooltipCopy) {
        return label;
    }

    return (
        <CopyToClipboardLink copyOnIconClick delay={1000} value={label}>
            {label}
        </CopyToClipboardLink>
    );
}

function TooltipContent({ title = null, subtitle = null, tooltipCopy = true }) {
    return (
        <span className={Style['infotext-tooltip__span-tooltip']}>
            <TooltipContentCopy label={title} tooltipCopy={tooltipCopy} />
            <TooltipContentCopy label={subtitle} tooltipCopy={tooltipCopy} />
        </span>
    );
}

export function InfoTextTooltip({ title, subtitle = null, className = '', tooltipCopy = false }) {
    return (
        <InfoText className={`${Style['infotext-tooltip']} ${className}`} subtitle={subtitle}>
            <Tooltip
                triggerOnHover
                position={'top-start'}
                title={<TooltipContent title={title} subtitle={subtitle} tooltipCopy={tooltipCopy} />}
                margin={false}
                mouseLeaveDelay={tooltipCopy ? 1000 : 0}
                tooltipWithCta={tooltipCopy}
            >
                <span>{title}</span>
            </Tooltip>
        </InfoText>
    );
}

InfoTextTooltip.propTypes = {
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    className: PropTypes.string
};
